import { DataTypes } from "../../../Common/Data/DataTypes";
import { BaseJSONXMLElement } from "./BaseJSONXMLElement";

export class JSONXMLBooleanElement extends BaseJSONXMLElement {
    readonly __type: string = "jsonboolean";
    readonly name: string = "Boolean Value";
    readonly ordinal: number = 2;
    readonly outputType: DataTypes = DataTypes.BOOLEAN;
    readonly styleElement: boolean = false;
}
